/**
 * useWilliamsChat — Chat hook for Williams caseload copilot.
 *
 * Thin adapter over the shared useChatCore engine (#931): supplies the
 * Williams SSE path and API calls. No action cards, no Guardian safety
 * checks, no bill attachments.
 */

import { useChatCore } from './useChatCore';
import { williamsApi } from '@/services/williamsApi';

export function useWilliamsChat(initialConversationId: string, sessionReady = true) {
  const core = useChatCore(initialConversationId, {
    ssePathPrefix: '/api/trfer/williams/stream',
    enabled: sessionReady,
    getHistory: (conversationId) => williamsApi.getHistory(conversationId),
    send: (conversationId, content) => williamsApi.sendStreamingMessage(conversationId, content),
  });

  return {
    messages: core.messages,
    status: core.status,
    isTyping: core.isTyping,
    isStreaming: core.isStreaming,
    error: core.error,
    conversationId: core.conversationId,
    sendMessage: core.sendMessage,
    switchConversation: core.switchConversation,
    startNewConversation: core.startNewConversation,
    dismissError: core.dismissError,
    // ── chat/voice parity (#1731, F-4) — engine state passed through ──
    sessionEnded: core.sessionEnded,
    markSessionEnded: core.markSessionEnded,
    markSessionResumed: core.markSessionResumed,
    isVoiceThread: core.isVoiceThread,
    versioningEnabled: core.versioningEnabled,
    historySettled: core.historySettled,
    reloadMessages: core.reloadMessages,
    retryMessage: core.retryMessage,
    chips: core.chips,
    failure: core.failure,
    reanchorKey: core.reanchorKey,
  };
}
